import { createContext, useContext, useState, useCallback } from 'react';
import { translations } from '@/data/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('pt');
  const t = translations[language];

  const switchLanguage = useCallback((lang) => {
    setLanguage(lang);
    document.documentElement.lang = lang === 'pt' ? 'pt-BR' : 'en';
  }, []);

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
